import { observer } from 'mobx-react-lite'
import { CollapseWithIcon } from 'shared/ui'
import { IntegrationSettingsProperty } from 'pages/settings/pages/integrations/pages/integrationSettings/ui/IntegrationSettingsProperty/IntegrationSettingsProperty'
import type { IntegrationSettingsPropertyStore } from 'pages/settings/pages/integrations/pages/integrationSettings/store/IntegrationSettingsPropertyStore'
import type { IntegrationCollapseSettingsStore } from 'pages/settings/pages/integrations/pages/integrationSettings/store/IntegrationCollapseSettingsStore'

import sharedStyles from 'pages/settings/pages/integrations/pages/integrationSettings/ui/styles.module.scss'

type ICollapseIntegrationSettingsPropertyProps = {
  collapseStore: IntegrationCollapseSettingsStore
  propertyStore: IntegrationSettingsPropertyStore
  is_1_0_request?: boolean
}

export const CollapseIntegrationSettingsProperty = observer(
  ({ collapseStore, propertyStore, is_1_0_request }: ICollapseIntegrationSettingsPropertyProps) => {
    return (
      <CollapseWithIcon
        opened={collapseStore.opened('property')}
        onClick={collapseStore.onToggle('property')}
        icon={'workflowOutline'}
        title={'Property mapping'}
        label={`${propertyStore.mappedLength} fields mapped`}
        headerClassName={sharedStyles.collapseWithIcon}
      >
        <IntegrationSettingsProperty store={propertyStore} is_1_0_request={is_1_0_request} />
      </CollapseWithIcon>
    )
  }
)
